module.exports = __webpack_public_path__ + "img/Professional-6.71ea84d9.png";